import React from 'react';
import MaterialTable from '../../../../../components/v4/MaterialTable';
import { axios } from '../../../../../services/axios';
import { useQuery } from 'hooks/useCustomQuery';

function useConsentHistory({ data, columns }) {
    const { data: historyTableData = [] } = useQuery({
        queryKey: ['consentHistory', data?.id],
        queryFn: async () => {
            const res = await axios.get(
                `/OperatorConnectOperatorConsent/${data.id}/History`,
            );
            return res.data;
        },
        enabled: Boolean(data?.id),
    });

    return { historyTableData, columns };
}

export default function ConsentHistory(props) {
    const { historyTableData, columns } = useConsentHistory(props);

    return (
        <React.Fragment>
            <MaterialTable
                title="Consent History"
                data={historyTableData}
                columns={columns}
            />
        </React.Fragment>
    );
}
